import AlertService from "../services/AlertService";

const storeKey = process.env.REACT_APP_USER_KEY;
const tokenKey = storeKey + "_tk";
const permissionKey = storeKey + "_per";

const handler = (err) => {
    if (err.message && err.message === "Failed to fetch") {
        const myResp = { isSuccess: false, errorMessage: "Server is not reachable!!" };
        const myOptions = { status: 200, statusText: "" };
        return new Response(JSON.stringify(myResp), myOptions);
    }
    if (err.status === 401) {
          AlertService.clear();
    sessionStorage.removeItem(storeKey);
    sessionStorage.removeItem(tokenKey);
    sessionStorage.removeItem(permissionKey);
    if (window.location.hash !== "#/login") {
      window.location.replace("#/login");
    }
    }
};

export default handler;
